import {Component} from 'vue-property-decorator';
import {CommonModelUtils, Filter, FilterRetrieveResponse} from '@/model/CommonModel';
import UserApi from '@/api/UserApi';
import FilterMixin from '@/components/table/filter/FilterMixin';

@Component
export default class CheckFilterMixin extends FilterMixin {
    protected filteredValue: string = '';
    protected filterType: string;
    
    public originFilters: Filter[] = [];
    public filters: Filter[] = [];
    
    get isAllChecked(): boolean {
        return this.filters.length === this.filteredValue?.split(',').length;
    }
    
    public loadFilter() {
        this.loading = true;
        UserApi.retrieveUserFilters(this.menuId, this.tableHeader.columnId)
               .then((res: FilterRetrieveResponse) => {
                   this.filterType = res.data.filterType;
                   this.filters = CommonModelUtils.getOrDefault(res.data.filterList, []);
                   this.originFilters = JSON.parse(JSON.stringify(this.filters));
        
                   this.filteredValue = this.filters
                                            .filter((item: Filter) => item.selected === 'Y')
                                            .map((item: Filter) => item.valueCode)
                                            .join(',');
               })
               .finally(() => this.loading = false);
    }
    
    public onAllCheck() {
        this.filteredValue = this.isAllChecked
            ? ''
            : this.filters.map((item: Filter) => item.valueCode).join(',');
    }
    
    public onDone() {
        const params = this.filteredValue.split(',')
                           .filter((value: string) => value)
                           .map((value: string) => {
                               return {
                                   filterType: this.filterType,
                                   valueCode: value,
                                   valueCode2: ''
                               };
                           });
    
        this.getFilterPromise(params)
            .then((res: any) => {
                this.visible = false;
                this.$emit('refresh');
            });
    }
    
    protected getFilterPromise(params: Filter[]) {
        const length = (params ?? []).length;
        if (length === 0 || length === this.filters.length) {
            return UserApi.deleteUserFilters(this.menuId, this.tableHeader.columnId);
        } else {
            return UserApi.updateUserFilters(this.menuId, this.tableHeader.columnId, params);
        }
    }
}
